import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	titleNonFinal: {
		id: 'eoc-changeboarding.optimal.wizard.steps.four.title-no-translate',
		defaultMessage: 'Ready to move from Opsgenie?',
		description: 'Title of step four for optimal tooling wizard',
	},
	descriptionNonFinal: {
		id: 'eoc-changeboarding.optimal.wizard.steps.four.description-no-translate',
		defaultMessage: "Here's a summary of what happens once you move:",
		description: 'Description of step four for optimal tooling wizard',
	},
	firstItemNonFinal: {
		id: 'eoc-changeboarding.optimal.wizard.steps.four.first-item-no-translate',
		defaultMessage:
			'Your Opsgenie data and settings will be copied to Jira Service Management, without any changes',
		description: 'First item in step four of optimal tooling wizard',
	},
	secondItemNonFinal: {
		id: 'eoc-changeboarding.optimal.wizard.steps.four.second-item-no-translate',
		defaultMessage:
			"You'll get a guide to finish setting up configurations that need your involvement",
		description: 'Second item in step four of optimal tooling wizard',
	},
	thirdItemNonFinal: {
		id: 'eoc-changeboarding.optimal.wizard.steps.four.third-item-no-translate',
		defaultMessage:
			"Your Opsgenie site will continue to be accessible, until it's turned off on {unlockDate}",
		description: 'Third item in step four of optimal tooling wizard',
	},
	fourthItemNonFinal: {
		id: 'eoc-changeboarding.optimal.wizard.steps.four.fourth-item-no-translate',
		defaultMessage:
			'Some of your data, including teams and team members, might change residency location from your selected server in Opsgenie. <link>Read more about data residency</link>',
		description: 'Fourth item in step four of optimal tooling wizard',
	},
	fifthItemNonFinal: {
		id: 'eoc-changeboarding.optimal.wizard.steps.four.fifth-item-no-translate',
		defaultMessage:
			'Inform your organization admin about this change as after the move, your teams and team members will become visible across all sites within your Atlassian account.',
		description: 'Fifth item in step four of optimal tooling wizard',
	},
	learnMoreNonFinal: {
		id: 'eoc-changeboarding.optimal.wizard.steps.four.learn-more-no-translate',
		defaultMessage: 'Read more about moving from Opsgenie',
		description: 'Learn more link for optimal tooling wizard',
	},
	dontReadyYetNonFinal: {
		id: 'eoc-changeboarding.optimal.wizard.steps.four.dont-ready-yet-no-translate',
		defaultMessage: "Don't feel ready yet? {link}",
		description: "Don't feel ready yet message for optimal tooling wizard",
	},
	primaryButtonTextNonFinal: {
		id: 'eoc-changeboarding.optimal.wizard.steps.four.primary-button-text-no-translate',
		defaultMessage: "Let's start moving",
		description: 'Primary button text for step four of optimal tooling wizard',
	},
});
